var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStep2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 22,
    viewBox: "0 0 28 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 22,
    rx: 10.5,
    fill: "#C5CAFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8913 15V14.04H13.3513L16.0633 10.656C16.5073 10.092 16.7353 9.48 16.7353 8.832C16.7353 8.172 16.5553 7.632 16.2073 7.236C15.7753 6.744 15.1633 6.504 14.3833 6.504C13.7473 6.504 13.1833 6.72 12.7033 7.164C12.2233 7.596 11.9473 8.136 11.8873 8.796L12.9073 8.988C13.0393 8.076 13.6033 7.464 14.3833 7.464C14.8273 7.464 15.1633 7.596 15.3913 7.872C15.5953 8.124 15.7033 8.436 15.7033 8.832C15.7033 9.372 15.5473 9.768 15.0193 10.428L11.7073 14.532V15H16.8913Z",
    fill: "#0E22F1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2);
export default __webpack_public_path__ + "static/media/step2.d2284c54.svg";
export { ForwardRef as ReactComponent };